import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  width: 100%;
  color: ${theme.colors.neutral[90]};
  font-size: ${theme.typography.sizes['xs']};
  line-height: ${theme.typography.lineHeight.md};
`

export const ObservationText = styled.p`
  line-height: ${theme.typography.lineHeight.md};
  color: ${theme.colors.neutral[90]};
  font-size: ${theme.typography.sizes['xs']};
  margin: 0;
`
